import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color", "strokeWidth", "withStroke"];
var __jsx = React.createElement;
import React from "react";
const ChevronRightIcon = _ref => {
  let {
      size = "16",
      color = "currentColor",
      strokeWidth = 0,
      withStroke
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  // Use withStroke to adjust strokeWidth if needed
  const finalStrokeWidth = withStroke ? strokeWidth || 1 : 0;
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    stroke: color,
    strokeWidth: finalStrokeWidth,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355L1.35355 13.3536C1.15829 13.5488 0.841709 13.5488 0.646447 13.3536C0.451184 13.1583 0.451184 12.8417 0.646447 12.6464L6.29289 7 0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z",
    fill: color
  }));
};
export default ChevronRightIcon;